import React from 'react';
import View from './view';

// Container component for handling business logic
const AcceptInvitationContainer = () => {
  // Add any container logic here if needed
  return <View />;
};

export default AcceptInvitationContainer;